import { render, staticRenderFns } from "./PromoCarousel.vue?vue&type=template&id=2b2788d3&"
import script from "./PromoCarousel.vue?vue&type=script&lang=ts&"
export * from "./PromoCarousel.vue?vue&type=script&lang=ts&"
import style0 from "./PromoCarousel.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports